// Conversões puras dos valores da proposta. O backend recebe `valor_str` com
// ponto decimal, portanto a normalização acontece aqui, antes de persistir.
import { parseDinheiroBr } from '../../utils/dinheiroInput';

function numeroDigitado(valor: string | number | null | undefined): number | null {
  const normalizado = parseDinheiroBr(String(valor ?? ''));
  if (!normalizado || normalizado === '.') return null;
  const numero = Number(normalizado);
  return Number.isFinite(numero) ? numero : null;
}

/** Valor monetário em formato canônico para o `parseFloat` do backend. */
export function valorMonetarioCanonico(valor: string | number | null | undefined): string {
  const numero = numeroDigitado(valor);
  return numero === null ? '' : numero.toFixed(2);
}

/** Alteração do percentual: o valor em reais acompanha o total da proposta. */
export function parcelaPorPercentual(totalVenda: number, percentual: string | number): {
  percentual: string;
  valor_str: string;
} {
  const percentualCanonico = parseDinheiroBr(String(percentual ?? ''));
  const percentualNumero = numeroDigitado(percentual);
  return {
    // O backend também usa parseFloat(percentual) como fallback. Por isso a
    // vírgula digitada precisa virar ponto antes de o estado ser persistido.
    percentual: percentualNumero === null ? '' : percentualCanonico,
    valor_str: percentualNumero === null ? '' : valorMonetarioCanonico((totalVenda * percentualNumero) / 100),
  };
}

/** Alteração do valor: o percentual é derivado; o valor fica canônico. */
export function parcelaPorValor(totalVenda: number, valor: string | number | null | undefined): {
  percentual: string;
  valor_str: string;
} {
  const valorCanonico = valorMonetarioCanonico(valor);
  const valorNumero = numeroDigitado(valorCanonico);
  return {
    valor_str: valorCanonico,
    percentual: valorNumero !== null && totalVenda > 0 ? ((valorNumero / totalVenda) * 100).toFixed(4) : '0',
  };
}
